import script from "./PdChip.vue?vue&type=script&setup=true&lang=js"
export * from "./PdChip.vue?vue&type=script&setup=true&lang=js"

import "./PdChip.vue?vue&type=style&index=0&id=626f7fc3&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626f7fc3"]])

export default __exports__